import React from "react";
import ClaroParagraph from '../../atoms/ClaroParagraph'
import ClaroPadding from '../../atoms/ClaroPadding'
import ClaroInput from '../../molecules/ClaroInput'
import ClaroSubtitleButton from '../../atoms/ClaroSubtitleButton'

class ClaroInputBlock extends React.Component {

    constructor(props, context){
        super(props, context)
        this.state = {
            showDetailComision:false
        }
    }

    handleOnclickDetailComision = () => {
        if(!this.state.showDetailComision){
            this.setState({showDetailComision:true})
        }else{
            this.setState({showDetailComision:false})
        }
    }

    render(){
        let { 
            comisionTitle,
            textTitleComision,
            comisionCard,
            comisionService,
            comisionTotal,
            range,
            type,
            field,
            subTitle,
            serviceName,
            title:{
                text, 
                imgHelp, 
                fontSize,
                titleStyle:{
                    align, 
                    weight, 
                    style
                }
            } 
        } = this.props;
        let claroParagraphTitle;
        let Font = fontSize;
        if(imgHelp){
            claroParagraphTitle = <ClaroParagraph id="234" {...weight} {...align} {...style} fontSize={Font}>
                {text + "\u00A0 \u00A0" } 
                {
                    <img 
                        style={{verticalAlign:"bottom"}} 
                        src={imgHelp}
                        onClick={this.props.handleClickTooltip}
                        data_type = {type}
                    />
                }
            </ClaroParagraph>
        } else{
            claroParagraphTitle = <ClaroParagraph id="234" {...weight} {...align} {...style} fontSize={Font}>
                {text} 
            </ClaroParagraph>
        }
        let idContainerInputCvv = "";
        let displayValue = true;
        if(type == "cvv"){
            idContainerInputCvv = "cvv-container-input";
            displayValue = false;
        } 
        return(
            <ClaroPadding {...field} id={idContainerInputCvv} style={{display:(displayValue)?"block":"none"}}>
                {claroParagraphTitle}
                <ClaroInput 
                    {...field}
                    {...range} 
                    serviceName={serviceName}
                />
                {subTitle ? 
                    (
                        <ClaroSubtitleButton  
                            {...subTitle.subTitleStyle.weight} 
                            {...subTitle.subTitleStyle.align} 
                            {...subTitle.subTitleStyle.style}
                            serviceName={serviceName}
                            text={subTitle.text}
                        >
                            {subTitle.text}
                        </ClaroSubtitleButton>
                    ):
                    (
                        <></>
                    )
                }
                {
                    comisionTitle && field.input.name == "amount" ? 
                    (
                        <>
                        <ClaroParagraph 
                            margin="2em 0em 0em .5em"  
                            normal={true} 
                            left={true} 
                            fontSize={"11px"} 
                            fontFamily={"AMX-Regular"}
                            fontColor="#a7a7a7"
                        > 
                            { textTitleComision + " $" + comisionTotal + " "} 
                            <div 
                                style={{
                                    height:"14px", 
                                    width:"24px", 
                                    display:"inline-block",
                                    margin:"0px 0px 0px 10px",
                                    textAlign:"center"
                                    
                                }}
                                onClick = {this.handleOnclickDetailComision}

                            >
                                <img 
                                    src={(this.state.showDetailComision)?"/images/flecha_arriba.png":"/images/flecha_abajo.png"} 
                                    alt="Logo" 
                                    height="10px" 
                                    width="12px" 
                                />
                            </div>
                        </ClaroParagraph>
                        
                        {
                            this.state.showDetailComision && (comisionService != "0.00" || comisionCard != "0.00")?(
                            <ClaroParagraph  margin="0em 0em 0em .5em" normal={true} left={true} fontSize={"11px"} fontFamily={"AMX-Regular"} fontColor="#a7a7a7">
                                {`Comisión por el pago de servicio: $ ${comisionService}` } 
                            </ClaroParagraph>) : ""
                        }
                        { 
                            this.state.showDetailComision && (comisionCard != "0.00" || comisionService != "0.00") ?(
                            <ClaroParagraph  margin="0em 0em 0em .5em" normal={true} left={true} fontSize={"11px"} fontFamily={"AMX-Regular"} fontColor="#a7a7a7">
                                { "Comisión por método de pago: $" + comisionCard }
                            </ClaroParagraph>) : ""
                        }
                        { 
                            this.state.showDetailComision && comisionCard == "0.00" && comisionService == "0.00"?(
                            <ClaroParagraph  margin="0em 0em 0em .5em" normal={true} left={true} fontSize={"11px"} fontFamily={"AMX-Regular"} fontColor="#a7a7a7">
                                { "Esta transacción no genera comisión." }
                            </ClaroParagraph>) : ""
                        }
                        { 
                            this.state.showDetailComision ?(
                            <ClaroParagraph  margin="0em 0em 0em .5em" normal={true} left={true} fontSize={"11px"} fontFamily={"AMX-Regular"} fontColor="#a7a7a7">
                                { "*IVA incluido" }
                            </ClaroParagraph>) : ""
                        }
                        
                        </>
                    ):""
                }
                
            </ClaroPadding>
        )
    }
}

export default ClaroInputBlock;